export default __webpack_public_path__ + "static/media/ada.1a1d648b.png";